import Vue from 'vue';
import Vuex from 'vuex';
import account from './modules/account';
import menu from './modules/menu';
import cny from './modules/cny';
import statement from './modules/statement';
import bankAccount from './modules/bankAccount';
import accounting from './modules/accounting';
import financialAnalysisItems from './modules/financialAnalysisItems';
import balanceItems from './modules/balanceItems';
import globalDialogState from './modules/globalDialogState';
import businessTax from './modules/businessTax';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        account,
        menu,
        cny,
        statement,
        bankAccount,
        accounting,
        financialAnalysisItems,
        balanceItems,
        globalDialogState,
        businessTax,
    },
});
